import script from "./BorderedBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./BorderedBlock.vue?vue&type=script&setup=true&lang=js"

import "./BorderedBlock.vue?vue&type=style&index=0&id=cca0dd6a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cca0dd6a"]])

export default __exports__